import { HpUserInteraction } from '@zg-rentals/ts-hotpads-api-client';

export type ContactHistoryListing = {
  aliasEncoded?: string;
  userItemTypes?: Array<string>;
  userItemDates?: { inquiry?: { date?: number } };
};

export function wasRecentlyContacted(listing: ContactHistoryListing | null | undefined, now = Date.now()): boolean {
  if (!listing?.userItemTypes?.includes(HpUserInteraction.INQUIRY)) return false;
  const timestamp = listing.userItemDates?.inquiry?.date;
  if (!timestamp) return true;
  const contacted = new Date(timestamp);
  const today = new Date(now);
  const months = today.getMonth() - contacted.getMonth() + 12 * (today.getFullYear() - contacted.getFullYear());
  return months < 3;
}
